import React from 'react';

import { Title, useAdaptive } from '@skillarea/lib-frontend';
import type { TSizesExtended } from '@skillarea/lib-frontend';

import cx from 'classnames';

import styles from './LayoutCard.module.scss';

type TLayoutCardProps = Omit<
  React.ComponentPropsWithoutRef<'section'>,
  'children' | 'className' | 'title'
> & {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  backgroundColor?: 'default' | 'accent';
  titleSize?: TSizesExtended;
  titleClassName?: string;
  hideTitleDivider?: boolean;
};

export const LayoutCard: React.FC<TLayoutCardProps> = ({
  backgroundColor = 'default',
  children,
  className,
  hideTitleDivider = false,
  title,
  titleClassName,
  titleSize,
  ...sectionProps
}) => {
  const titleColor = backgroundColor === 'accent' ? 'text' : 'contrast';
  const { isMobile, isTablet } = useAdaptive();
  titleSize = titleSize ?? (isMobile ? 'xs' : isTablet ? 's' : 'm');

  return (
    <section
      {...sectionProps}
      className={cx(
        styles.card,
        backgroundColor === 'accent' && styles.accent,
        className,
      )}
    >
      {title ? (
        <>
          <Title
            className={titleClassName}
            color={titleColor}
            size={titleSize}
            variant="benzin"
          >
            {title}
          </Title>
          {!hideTitleDivider && <div aria-hidden className={styles.divider} />}
        </>
      ) : null}
      {children}
    </section>
  );
};
